import {mapActions} from 'vuex'

export default {
  data () {
    return {
      navigateCache: {}
    }
  },
  methods: {
    ...mapActions(['addMainTabAction']),
    navigateCacheGet (menus) {
      return new Promise((resolve, reject) => {
        if (menus && menus.length) {
          let current = this.navigateCache
          for (let i = 0; i < menus.length; i++) {
            let node = current[menus[i]]
            if (i < menus.length - 1) {
              current = node.nodes
            } else {
              current = node.value
            }
            if (typeof current === 'undefined') {
              reject(new Error('暂无缓存记录'))
              return
            }
          }
          resolve(current)
        } else {
          reject(new Error('导航参数为空'))
        }
      })
    },
    navigateCachePut (menus, paths) {
      if (menus && menus.length) {
        let current = this.navigateCache
        for (let i = 0; i < menus.length; i++) {
          let node = current[menus[i]] = current[menus[i]] || {}
          if (i < menus.length - 1) {
            current = node.nodes = node.nodes || {}
            if (paths && i < paths.length) {
              node.value = paths.slice(0, i + 1)
            }
          } else {
            node.value = paths
          }
        }
      }
    },
    navigateToPath (menus, onSuccess, onError) {
      let pathResolve = new Promise((resolve, reject) => {
        if (menus && menus.length) {
          this.navigateCacheGet(menus)
            .then(paths => {
              resolve(paths)
            })
            .catch(() => {
              this.$ajax({
                url: '/workspace/manager/center/paths',
                method: 'post',
                data: this.$qs.stringify({
                  menus: menus
                }, {
                  arrayFormat: 'repeat'
                })
              }).then(response => {
                if (response.data) {
                  switch (response.data['responseCode']) {
                    case 'SUCCESS': {
                      let paths = response.data['paths'] || []
                      this.navigateCachePut(menus, paths)
                      resolve(paths)
                      break
                    }
                    default: {
                      reject(new Error(response.data['message'] || '获取导航路径异常'))
                      break
                    }
                  }
                }
              }, () => {
                reject(new Error('请求发送失败'))
              })
            })
        } else {
          reject(new Error('导航参数为空'))
        }
      })
      pathResolve.then(paths => {
        this.handleSwitchPath(paths, onSuccess)
      }).catch(err => {
        if (typeof onError === 'function') {
          onError(err)
        }
      })
    },
    handleSwitchPath (paths, onCallback) {
      if (paths && paths.length) {
        let mainPath = paths[0]
        this.addMainTabAction({
          name: mainPath.name,
          label: mainPath.label,
          icon: mainPath.icon,
          path: mainPath.path
        }).then(() => {
          // 如果只有一级菜单则无需再次跳转
          this.handleSwitchDepthPath(paths, 2, onCallback)
        })
      }
    },
    handleSwitchDepthPath (paths, depth, onCallback) {
      if (depth <= paths.length) {
        this.$nextTick(() => {
          this.$router.replace(paths.slice(0, depth).map(item => item.path).join(''))
          this.handleSwitchDepthPath(paths, depth + 1, onCallback)
        })
      } else {
        if (typeof onCallback === 'function') {
          this.$nextTick(() => onCallback())
        }
      }
    }
  }
}
